import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import FeatherIcon from "feather-icons-react";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const Timestamps = () => {
  const timestamps = [
    { label: "Impact Started", time: "10/30/24, 3:30 PM" },
    { label: "Declared", time: "10/30/24, 3:31 PM" },
    { label: "Identified", time: "10/30/24, 3:35 PM" },
    { label: "Fixed", time: "10/30/24, 3:37 PM" },
    { label: "Resolved", time: "10/30/24, 4:10 PM" },
    { label: "Closed", time: "10/30/24, 4:10 PM" },
  ];

  return (
    <div className="p-4">
      <Card className="shadow-sm border" style={cardShell}>
        <CardBody className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-bold mb-0">Timestamps</h6>
            <FeatherIcon
              icon="edit-2"
              size={16}
              style={{ cursor: "pointer", color: "#777c80ff" }}
            />
          </div>

          {timestamps.map((item, index) => (
            <Row key={index} className="mb-2">
              <Col md={5}>
                <p
                  className="mb-0"
                  style={{
                    fontSize: "13px",
                    color: "#88929bff",
                    fontWeight: "400",
                  }}
                >
                  {item.label}
                </p>
              </Col>
              <Col md={7}>
                <p
                  className="mb-0"
                  style={{
                    fontSize: "13px",
                    color: "#697077ff",
                    fontWeight: "500",
                  }}
                >
                  {item.time}
                </p>
              </Col>
            </Row>
          ))}
        </CardBody>
      </Card>
    </div>
  );
};

export default Timestamps;
